import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { motion } from 'framer-motion';
import getStyles from './styles';
import { Controller, useForm } from 'react-hook-form';
import axios from 'axios';
import SuccessModal from '../../../components/SuccessModal/SuccessModal';

const ContactSection = () => {
  const styles = getStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { handleSubmit, control, reset } = useForm({});

  const onSubmit = (data) => {
    const config = {
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    };
    var req = {
      Name: data.fullName,
      Age: data.age,
      Email: data.email,
      MobileNumber: data.phone,
      ProfileLink: data.profileLink,
      City: data.city,
      State: data.state,
      Occupation: data.occupation,
      WhyJoin: data.whyJoin,
      ProblemSolved: data.problemSolved,
      MiniTask: data.miniTask,
      Commitment: data.commitment
    };
    return axios
      .post('https://formspree.io/f/xpwgyrwz', req, config)
      .then((result) => {
        if (result.data) {
          reset();
          setIsModalOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box component="section" sx={styles.section} id="apply">
      <Container maxWidth="lg" sx={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box sx={styles.formWrapper}>
            <Box sx={styles.header}>
              <Typography variant="h2" sx={styles.title}>
                Apply for the Fellowship
              </Typography>
              <Typography variant="body1" sx={styles.subtitle}>
                Join a community of builders, leaders, and innovators. Fill out
                the form below to start your journey.
              </Typography>
            </Box>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Typography variant="h4" sx={styles.sectionTitle}>
                Personal Information
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      Full Name <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="fullName"
                      control={control}
                      defaultValue=""
                      rules={{ required: 'Full Name is required' }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your Full Name"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      Age <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="age"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: 'Age is required',
                        pattern: {
                          value: /^[0-9]{2}$/,
                          message: 'Age must be exactly 2 digits'
                        }
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your Age"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      Email Address <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="email"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: 'Email is required',
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                          message: 'Enter a valid email address'
                        }
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your Email Address"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      Phone Number <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="phone"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: 'Mobile number is required',
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: 'Mobile number must be exactly 10 digits'
                        }
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your Mobile Number"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      LinkedIn / Social Media Profile{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="profileLink"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: 'LinkedIn / Social Media Profile is required',
                        pattern: {
                          value:
                            /^(https?:\/\/)?(www\.)?(linkedin\.com\/(in|company)\/[A-Za-z0-9._\-/?=&#%]+|instagram\.com\/[^/]+|github\.com\/[^/]+|x\.com\/[^/]+|twitter\.com\/[^/]+|facebook\.com\/[^/]+|dribbble\.com\/[^/]+|behance\.net\/[^/]+)\/?$/i,
                          message: 'Enter a valid URL'
                        }
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your LinkedIn / Social Media Profile"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      City <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="city"
                      control={control}
                      defaultValue=""
                      rules={{ required: 'City is required' }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your City"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      State <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="state"
                      control={control}
                      defaultValue=""
                      rules={{ required: 'State is required' }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your State"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={styles.inputGroup}>
                    <Typography component="label" sx={styles.label}>
                      Current Education / Occupation{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Controller
                      name="occupation"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: 'Current Education / Occupation is required'
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          placeholder="Enter your Current Education / Occupation"
                          fullWidth
                          margin="normal"
                          error={!!error}
                          helperText={error?.message}
                          sx={styles.textField}
                        />
                      )}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Typography variant="h4" sx={styles.sectionTitle}>
                Motivation & Mindset
              </Typography>
              <Box sx={styles.inputGroup}>
                <Typography component="label" sx={styles.label}>
                  Why do you want to join this fellowship? (100–200 words){' '}
                  <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Controller
                  name="whyJoin"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: 'This field is required',
                    validate: (value) => {
                      const wordCount = value.trim().split(/\s+/).length;
                      if (wordCount > 200) {
                        return 'Maximum 200 words allowed';
                      }
                      return true;
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      placeholder="Describe your answer"
                      fullWidth
                      multiline
                      rows={4}
                      margin="normal"
                      error={!!error}
                      helperText={error?.message}
                      sx={styles.textField}
                    />
                  )}
                />
              </Box>
              <Box sx={styles.inputGroup}>
                <Typography component="label" sx={styles.label}>
                  {' '}
                  Tell us about a problem you have solved or a challenge you
                  overcame. (100–150 words){' '}
                  <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Controller
                  name="problemSolved"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: 'This field is required',
                    validate: (value) => {
                      const wordCount = value.trim().split(/\s+/).length;
                      if (wordCount > 150) {
                        return 'Maximum 150 words allowed';
                      }
                      return true;
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      placeholder="Describe your answer"
                      fullWidth
                      multiline
                      rows={4}
                      margin="normal"
                      error={!!error}
                      helperText={error?.message}
                      sx={styles.textField}
                    />
                  )}
                />
              </Box>
              <Typography variant="h4" sx={styles.sectionTitle}>
                Mini Task (Problem + Solution Idea)
              </Typography>
              <Box sx={styles.inputGroup}>
                <Typography component="label" sx={styles.label}>
                  Instructions: Pick any product, service, or system you use
                  frequently (app, website, tool, or college process).
                  <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: '#64748b', marginBottom: '12px' }}
                >
                  <strong>a.</strong> Identify 1–3 problems with it. <br />
                  <strong>Example:</strong> Zomato app – confusing discounts,
                  hard to track past orders. <br />
                  <br />
                  <strong>b.</strong> Suggest 1–3 simple solutions or
                  improvements. <br />
                  <strong>Example:</strong> Add a ‘repeat favorite orders’
                  button, highlight applicable discounts.
                </Typography>
                <Controller
                  name="miniTask"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: 'This field is required',
                    validate: (value) => {
                      const wordCount = value.trim().split(/\s+/).length;
                      if (wordCount > 300) {
                        return 'Maximum 300 words allowed';
                      }
                      return true;
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      placeholder="Describe your answer (Max 300 words)"
                      fullWidth
                      multiline
                      rows={6}
                      margin="normal"
                      error={!!error}
                      helperText={error?.message}
                      sx={styles.textField}
                    />
                  )}
                />
              </Box>
              {/* <Typography variant="h4" sx={styles.sectionTitle}>
                Optional / Bonus
              </Typography>
              <Box sx={styles.inputGroup}>
                <Typography component="label" sx={styles.label}>
                  Have you ever run a small project, side business, or
                  initiative? If yes, briefly describe it. (50–100 words){' '}
                </Typography>
                <Controller
                  name="smallProject"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: 'false',
                    validate: (value) => {
                      const wordCount = value.trim().split(/\s+/).length;
                      if (wordCount > 100) {
                        return 'Maximum 100 words allowed';
                      }
                      return true;
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      placeholder="Describe your answer"
                      fullWidth
                      multiline
                      rows={3}
                      margin="normal"
                      error={!!error}
                      helperText={error?.message}
                      sx={styles.textField}
                    />
                  )}
                />
              </Box>
              <Box sx={styles.inputGroup}>
                <Typography component="label" sx={styles.label}>
                  Any other skills or experiences you think are relevant to this
                  fellowship?
                </Typography>
                <Controller
                  name="skills"
                  control={control}
                  defaultValue=""
                  rules={{ required: false }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      placeholder="Describe your answer"
                      fullWidth
                      multiline
                      rows={3}
                      margin="normal"
                      error={!!error}
                      helperText={error?.message}
                      sx={styles.textField}
                    />
                  )}
                />
              </Box> */}
              <Typography variant="h4" sx={styles.sectionTitle}>
                {' '}
                Commitment <span style={{ color: 'red' }}>*</span>
              </Typography>{' '}
              <Box sx={styles.inputGroup}>
                <Controller
                  name="commitment"
                  control={control}
                  rules={{ required: 'You must accept the commitment.' }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...field}
                            checked={!!field.value}
                            sx={{
                              color: '#2563eb',
                              '&.Mui-checked': { color: '#1e40af' }
                            }}
                          />
                        }
                        label="I understand this is a 2-week Phase 1 screening program and I am ready to commit fully."
                        sx={styles.checkboxLabel}
                      />
                      {error && (
                        <Typography color="error" variant="caption">
                          {error.message}
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Box>{' '}
              {/* <Box sx={styles.inputGroup}>
                <Controller
                  name="feePaid"
                  control={control}
                  rules={{ required: 'Payment confirmation is required.' }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...field}
                            checked={!!field.value}
                            sx={{
                              color: '#2563eb',
                              '&.Mui-checked': { color: '#1e40af' }
                            }}
                          />
                        }
                        label="Entry Fee: ₹499 (paid via [payment method]). Payment confirmation attached"
                        sx={styles.checkboxLabel}
                      />
                      {error && (
                        <Typography color="error" variant="caption">
                          {error.message}
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Box> */}
              <Box sx={{ textAlign: 'center' }}>
                <Button type="submit" sx={styles.submitButton}>
                  Submit Application
                </Button>
              </Box>
            </form>
          </Box>
        </motion.div>
      </Container>
      <SuccessModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Box>
  );
};

export default ContactSection;
